import { useState } from "react";
import { TRACKING_NAF_OPTIONS } from "../../../../constants";
import LoadingButton from "../../../generic-components/button";
import { useMutation } from "@apollo/client";
import { logoutUser } from "../../../../graphql/mutations/logoutUser";
import { removeCookies } from "../../../../helpers";
import useStepper from "../../../../hooks/useStepper";

const LogoutButton = () => {
  const { setSaveError, setErrorToast } = useStepper();
  const [logout] = useMutation(logoutUser);

  const [isLoading, setIsLoading] = useState();

  const handleLogout = () => {
    setIsLoading(true);
    logout({
      onCompleted: (data) => {
        removeCookies();
        window.location.href = data?.destroy_session?.logout_url;
      },
      onError: (error) => {
        if (error.message === "Token has expired") {
          removeCookies();
          window.location.href = process.env.REACT_APP_AVCWISE_URL;
        } else {
          setIsLoading(false);
          setSaveError(error);
          setErrorToast(true);
        }
      },
    });
  };
  return (
    <LoadingButton
      buttonTitle="LOGOUT"
      trackingDetails={TRACKING_NAF_OPTIONS}
      loading={isLoading}
      handleClick={handleLogout}
      styleClass="Header-outlined-btn Header-outlined-btn-sm"
    />
  );
};

export default LogoutButton;
